import React, { useState, useEffect } from "react";
import ImageCropper from "../ImageCropper";
import FileUpload, { ImageDisplay } from "../FileUpload";
import assets from "../../../../../../assets/assets";
import { useContract } from "../../../../../../provider/ContractProvider";
import TextInput from "../TextInput";
import ActionButtons from "../ActionButtons";
import axios from "axios";
import { distributionUrl } from "../../../../../Config/url";
import { useAxiosConfigGlobal } from "../../../../../Config/axios";

const Person = () => {
  const { data, setData, handleNext, handlePrevious } = useContract();
  const axiosConfig = useAxiosConfigGlobal();

  const [formErrors, setFormErrors] = useState({
    name: "",
    first_name: "",
    last_name: "",
    registration_number: "",
    passport_front: "",
    passport_back: "",
    signature: "",
  });

  const [imageState, setImageState] = useState({
    passport_front: {
      currentPage: "choose-img",
      imgAfterCrop: "",
      image: "",
      imageType: "passport_front",
      borderType: "dashed",
    },
    passport_back: {
      currentPage: "choose-img",
      imgAfterCrop: "",
      imageType: "passport_back",
      borderType: "dashed",
    },
    signature: {
      currentPage: "choose-img",
      imgAfterCrop: "",
      imageType: "signature",
      borderType: "solid",
    },
  });

  const onImageSelected = (selectedImg, imageType) => {
    setImageState((prevState) => ({
      ...prevState,
      [imageType]: {
        ...prevState[imageType],
        image: selectedImg,
        currentPage: "crop-img",
      },
    }));
  };

  const handleInputChange = (name) => (e) => {
    setData((prevText) => ({
      ...prevText,
      [name]: e.target.value,
    }));
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const streamImage = async (imageData) => {
    try {
      const response = await axios.get(
        `${distributionUrl}stream/panel/file?url=true&path=${imageData.path}`,
        axiosConfig
      );
      imageData.url = response.data.url;
    } catch (error) {
      console.error("Failed to stream image:", error);
    }
  };

  const onCropDone = async (imgData, imageType) => {
    await streamImage(imgData);
    setImageState((prevState) => ({
      ...prevState,
      [imageType]: {
        ...prevState[imageType],
        currentPage: "display-img",
        imgAfterCrop: imgData.url,
      },
    }));

    setData((prevData) => ({
      ...prevData,
      [imageType]: imgData,
    }));
  };

  const onCropCancel = (imageType) => {
    setImageState((prevState) => ({
      ...prevState,
      [imageType]: {
        ...(prevState[imageType] || {}),
        image: "",
        imgAfterCrop: "",
        currentPage: "choose-img",
      },
    }));
    setData((prevData) => ({
      ...prevData,
      [imageType]: {},
    }));
  };

  useEffect(() => {
    if (data?.passport_front?.url) {
      setImageState((prevState) => ({
        ...prevState,
        passport_front: {
          ...prevState.passport_front,
          image: data.passport_front.url,
          currentPage: "display-img",
        },
      }));
    }

    if (data?.passport_back?.url) {
      setImageState((prevState) => ({
        ...prevState,
        passport_back: {
          ...prevState.passport_back,
          image: data.passport_back.url,
          currentPage: "display-img",
        },
      }));
    }

    if (data?.signature?.url) {
      setImageState((prevState) => ({
        ...prevState,
        signature: {
          ...prevState.signature,
          image: data.signature.url,
          currentPage: "display-img",
        },
      }));
    }
  }, [data]);

  const isFormValid =
    data.first_name &&
    data.last_name &&
    data.registration_number &&
    data.passport_front &&
    data.passport_back &&
    data.signature;

  const validateForm = () => {
    const errorMessages = {
      first_name: "Нэрээ оруулна уу.",
      last_name: "Овгоо оруулна уу.",
      registration_number: "Pегистрийн дугаараа оруулна уу.",
      passport_front: "Иргэний үнэмлэхний ур талын зурагаа оруулна уу.",
      passport_back: "Иргэний үнэмлэхний хойд талын зурагаа оруулна уу.",
      signature: "Гарын үсэгнийхээ зурагаа оруулна уу.",
    };

    const errors = Object.keys(errorMessages).reduce((acc, field) => {
      if (!data[field]) acc[field] = errorMessages[field];
      return acc;
    }, {});

    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      setFormErrors({}); // ✅ Дата зөв байвал алдаануудыг арилгах
      return true;
    }

    return false;
  };

  useEffect(() => {
    if (data) {
      setFormErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };

        Object.keys(updatedErrors).forEach((key) => {
          if (data[key]) {
            delete updatedErrors[key]; // ✅ Дата орж ирсэн бол тухайн талбарын алдааг арилгах
          }
        });

        return updatedErrors;
      });
    }
  }, [data]); // 🔄 data өөрчлөгдөх бүрт ажиллана
  const onSubmit = () => {
    if (validateForm()) {
      handleNext();
    } else {
      return;
    }
  };

  return (
    <>
      <div className="flex flex-col gap-6 px-6 pb-16">
        <div className="flex items-center gap-6">
          <TextInput
            type="text"
            label="Овог*"
            name="last_name"
            placeholder="Овгоо оруулна уу"
            value={data.last_name ?? ""}
            onChange={handleInputChange("last_name")}
            error={formErrors.last_name}
          />
          <TextInput
            type="text"
            label="Таны нэр*"
            name="first_name"
            placeholder="Нэрээ оруулна уу"
            value={data.first_name ?? ""}
            onChange={handleInputChange("first_name")}
            error={formErrors.first_name}
          />
        </div>

        <TextInput
          type="text"
          label="Хаяг"
          name="address"
          placeholder="Гэрийн хаягаа оруулна уу"
          value={data.address ?? ""}
          onChange={handleInputChange("address")}
          error={formErrors.address}
        />
        <TextInput
          type="text"
          label="Регистрийн дугаар*"
          name="registration_number"
          placeholder="Pегистрийн дугаар оруулна уу"
          value={data.registration_number ?? ""}
          onChange={handleInputChange("registration_number")}
          error={formErrors.registration_number}
        />

        <div className="flex items-center gap-6">
          <div className="w-full">
            <h5 className="paragraph-CK">Иргэний үнэмлэхний урд тал*</h5>
            <div className="text-input mt-1.5">
              {imageState.passport_front.currentPage === "choose-img" ? (
                <FileUpload
                  onImageSelected={(img) =>
                    onImageSelected(img, "passport_front")
                  }
                  borderType={imageState.passport_front.borderType}
                  icon={assets.svg.addImage}
                />
              ) : imageState.passport_front.currentPage === "crop-img" ? (
                <ImageCropper
                  imageType="passport_front"
                  image={imageState.passport_front.image}
                  onCropDone={async (data) =>
                    await onCropDone(data, "passport_front")
                  }
                  onCropCancel={() => onCropCancel("passport_front")}
                />
              ) : (
                <ImageDisplay
                  borderType={imageState.passport_front.borderType}
                  imgAfterCrop={data.passport_front}
                  setCurrentPage={(page) =>
                    setImageState({
                      ...imageState,
                      passport_front: {
                        ...imageState.passport_front,
                        currentPage: page,
                      },
                    })
                  }
                />
              )}
              {formErrors.passport_front && (
                <p className="text-red-500 text-xs mt-1">
                  {formErrors.passport_front}
                </p>
              )}
            </div>
          </div>
          <div className="w-full">
            <h5 className="paragraph-CK">Иргэний үнэмлэхний ард тал*</h5>
            <div className="text-input mt-1.5">
              {imageState.passport_back.currentPage === "choose-img" ? (
                <FileUpload
                  onImageSelected={(img) =>
                    onImageSelected(img, "passport_back")
                  }
                  borderType={imageState.passport_back.borderType}
                  icon={assets.svg.addImage}
                />
              ) : imageState.passport_back.currentPage === "crop-img" ? (
                <ImageCropper
                  imageType="passport_back"
                  image={imageState.passport_back.image}
                  onCropDone={async (data) =>
                    await onCropDone(data, "passport_back")
                  }
                  onCropCancel={() => onCropCancel("passport_back")}
                />
              ) : (
                <ImageDisplay
                  borderType={imageState.passport_back.borderType}
                  imgAfterCrop={data.passport_back}
                  setCurrentPage={(page) =>
                    setImageState({
                      ...imageState,
                      passport_back: {
                        ...imageState.passport_back,
                        currentPage: page,
                      },
                    })
                  }
                />
              )}
              {formErrors.passport_back && (
                <p className="text-red-500 text-xs mt-1">
                  {formErrors.passport_back}
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="w-full">
          <h5 className="paragraph-CK">Гарын үсэг*</h5>
          <div className="text-input mt-1.5">
            {imageState.signature.currentPage === "choose-img" ? (
              <FileUpload
                onImageSelected={(img) => onImageSelected(img, "signature")}
                borderType={imageState.signature.borderType}
                icon={assets.svg.addImage}
              />
            ) : imageState.signature.currentPage === "crop-img" ? (
              <ImageCropper
                imageType="signature"
                image={imageState.signature.image}
                onCropDone={async (data) => await onCropDone(data, "signature")}
                onCropCancel={() => onCropCancel("signature")}
              />
            ) : (
              <ImageDisplay
                borderType={imageState.signature.borderType}
                imgAfterCrop={data.signature}
                setCurrentPage={(page) =>
                  setImageState({
                    ...imageState,
                    signature: {
                      ...imageState.signature,
                      currentPage: page,
                    },
                  })
                }
              />
            )}
            {formErrors.signature && (
              <p className="text-red-500 text-xs mt-1">
                {formErrors.signature}
              </p>
            )}
          </div>
        </div>
      </div>
      <ActionButtons
        handlePrevious={handlePrevious}
        onSubmit={onSubmit}
        isFormValid={isFormValid}
        previousLabel="Буцах"
        submitLabel="Үргэлжлүүлэх"
      />
    </>
  );
};

export default Person;
